import React, { Fragment, useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Redirect, useLocation, useHistory } from "react-router-dom"
import "../css/login.css"
import { resetPasswordAction } from "../actions/userActions"
import { useTranslation } from "react-i18next"
import { ROUTES } from "../utils"

const PageResetPassword = () => {
	const history = useHistory()
	const location = useLocation()
	const [t] = useTranslation("global")
	const dispatch = useDispatch()
	const [newPassword, setNewPassword] = useState("") // default_test_password: testergo
	const [confirmPassword, setConfirmPassword] = useState("") // default_test_password: testergo
	const [showNewPassword, setShowNewPassword] = useState(false)
	const [showConfirmPassword, setShowConfirmPassword] = useState(false)
	const [error, showError] = useState(false)
	const [showErrorMessage, setShowErrorMessage] = useState(false)
	const users = useSelector((state) => state.users)

	const anzyz_legal_logo = window._env_.REACT_APP_DASHBOARD_LOGO || anzyz_logo

	function validatePasswords(newPassword, confirmPassword) {
		const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[(!@#$%^&*.)])[A-Za-z\d(!@#$%^&*.)]{8,20}$/
		if (newPassword !== confirmPassword) {
			setShowErrorMessage(t("user.formErrors.passwordMustMatch"))
			showError(true)
			return false // Passwords do not match
		}
		if (!passwordRegex.test(newPassword)) {
			setShowErrorMessage(t("user.formErrors.password"))
			showError(true)
			return false // New password does not meet complexity requirements
		}
		setShowErrorMessage(true)
		showError(false)
		return true
	}

	const submitLogin = () => {
		const shouldTriggerReset = validatePasswords(newPassword, confirmPassword)
		if (shouldTriggerReset) {
			dispatch(
				resetPasswordAction({
					new_password: newPassword,
				})
			)
		}
	}

	useEffect(() => {
		const backgroundImg = window._env_.REACT_APP_BACKGROUND
		document.body.style.backgroundImage = "url('" + backgroundImg + "')"
		document.body.classList.add("newLoginPage")
		const params = location.pathname
		const token = params.split("/")[2]
		const resetToken = {
			token: {
				access_token: token,
			},
		}
		localStorage.setItem("user", JSON.stringify(resetToken))
		return () => {
			document.body.style.backgroundImage = "none"
			document.body.classList.remove("newLoginPage")
			localStorage.removeItem("user")
		}
	}, [])
	useEffect(() => {
		if (users?.redirectToHome) {
			history.push(ROUTES.DEFAULT, { from: "resetPassword", error: t("forgotPassword.resetPasswordLinkExpire") })
		}
	}, [users])

	return (
		<Fragment>
			<div className="wrapper bg-white">
				<div className="h2 text-center">
					<img src={anzyz_legal_logo} width="100%" height="auto" alt=" " className="logo_producto" />
				</div>

				<Fragment>
					<div className="h4 text-muted text-center pt-2">{t("forgotPassword.resetYourPassword")}</div>
					<div className="pt-3">
						<div className="form-group py-1 pb-2">
							<div className="input-field">
								{" "}
								<span className="fas fa-lock p-2"></span>{" "}
								<input
									type={showNewPassword ? "text" : "password"}
									placeholder="Enter New Password"
									required
									className="qa-password"
									value={newPassword}
									data-testid="newPassword"
									data-cy="password_input"
									onChange={(e) => setNewPassword(e.target.value)}
									onFocus={() => {
										setShowErrorMessage(true)
										showError(false)
									}}
								/>{" "}
								<a
									className="btn bg-white text-muted"
									onClick={(e) => {
										e.preventDefault()
										setShowNewPassword(!showNewPassword)
									}}
								>
									{" "}
									<span className={showNewPassword ? "far fa-eye-slash" : "far fa-eye"}></span>{" "}
								</a>{" "}
							</div>
						</div>
						{error && <div style={{ paddingBottom: "20px", color: "red" }}>{showErrorMessage}</div>}
						<div className="form-group py-1 pb-2">
							<div className="input-field">
								{" "}
								<span className="fas fa-lock p-2"></span>{" "}
								<input
									type={showConfirmPassword ? "text" : "password"}
									placeholder="Confirm Password"
									required
									className="qa-password"
									value={confirmPassword}
									data-testid="confirmPassword"
									data-cy="password_input"
									onChange={(e) => setConfirmPassword(e.target.value)}
									onFocus={() => {
										setShowErrorMessage(true)
										showError(false)
									}}
								/>{" "}
								<a
									className="btn bg-white text-muted"
									onClick={(e) => {
										e.preventDefault()
										setShowConfirmPassword(!showConfirmPassword)
									}}
								>
									{" "}
									<span className={showConfirmPassword ? "far fa-eye-slash" : "far fa-eye"}></span>{" "}
								</a>{" "}
							</div>
						</div>
					</div>
					<div className="d-flex align-items-start  my-3">
						<button
							onClick={() => {
								submitLogin()
							}}
							className="btn btn-block text-center qa-login"
							data-testid="login_submit"
							data-cy="login_submit"
							disabled={!(confirmPassword?.length > 0 && newPassword?.length > 0)}
						>
							{t("forgotPassword.resetPassword")}
						</button>
					</div>
				</Fragment>
			</div>
		</Fragment>
	)
}

export default PageResetPassword
